const URL_REGEX = /https?:\/\/[^\s<>"')\]]+/g

export function extractUrls(text: string): string[] {
  return Array.from(text.matchAll(URL_REGEX), (m) => m[0])
}
